import { useTranslation } from 'react-i18next';
import Title from '../../components/Title/Title';
import PageWrapper from '../PageWrapper/PageWrapper';
import VisitList from './graphs/VisitList';
import Card from '../../components/Card/Card';
import MonthlyTabletVisitsPerCollection from './graphs/MonthlyTabletVisitsPerCollection';
import TotalTabletVisitsPerCollection from './graphs/TotalTabletVisitsPerCollection';
import WeddingDates from './graphs/WeddingDates';
import MostEyeCatchingDressesPerYear from './graphs/TotalYear';
import { AdminRestricted } from '../../components/AdminRestricted/AdminRestricted';

function TabletStatisticsPage() {

  const { t } = useTranslation();

  return (
    <PageWrapper>
      <AdminRestricted>
      <>
        <Title text={t("stats.tablet")} />
        <div className="grid md:grid-cols-2 gap-4">
          <Card>
            <>
              <MonthlyTabletVisitsPerCollection />
              <br/>
              <TotalTabletVisitsPerCollection />
            </>
          </Card>
          <Card>
            <>
              <WeddingDates />
              <br/>
              <VisitList />
            </>
          </Card>
        </div>
        <Card>
          <MostEyeCatchingDressesPerYear />
        </Card>
        <br/>
      </>
      </AdminRestricted>
    </PageWrapper>
  );
}

export default TabletStatisticsPage;
